import "./AdminMobileMenu.css";
import React, { useEffect } from "react";

import FoodIcon from "../../assets/imgs/food-icon.svg";
import FoodSelectedIcon from "../../assets/imgs/food-selected-icon.svg";
import DashboardIcon from "../../assets/imgs/dashboard-icon.svg";
import DashboardSelectedIcon from "../../assets/imgs/dashboard-selected-icon.svg";
import NoteFavoriteIcon from "../../assets/imgs/note-favorite-icon.svg";
import NoteFavoriteSelectedIcon from "../../assets/imgs/note-favorite-selected-icon.svg";
import CloseIcon from "../../assets/imgs/close-icon-gray.svg";
import TextLogo from "../../assets/imgs/text-logo.svg";
import UserNetworkMenuIcon from "./UserNetworkMenuIcon";
import loginService from "../../services/login-service";

const ADMIN_MENU_ITEMS = [
  {
    title: "Alimentos",
    href: "/foodstuffs",
    isActive: (page) => page === "create-foodstuff" || page.startsWith("foodstuffs"),
    icon: FoodIcon,
    selectedIcon: FoodSelectedIcon,
  },
  {
    title: "Usuários",
    href: "/users",
    isActive: (page) => page === "users" || page === "user-profile",
    useUserIcon: true,
  },
  {
    title: "Dashboard",
    href: "/home",
    isActive: (page) => page === "home",
    icon: DashboardIcon,
    selectedIcon: DashboardSelectedIcon,
  },
  {
    title: "Solicitações",
    href: "/foodstuff-suggestions",
    isActive: (page) => page === "foodstuff-suggestions",
    icon: NoteFavoriteIcon,
    selectedIcon: NoteFavoriteSelectedIcon,
  },
];

const getUserInitials = (name) => {
  if (!name) {
    return "";
  }

  const names = name.trim().split(" ");
  if (names.length > 1) {
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
  }

  return names[0].charAt(0).toUpperCase();
};

const AdminMobileMenu = ({ isOpen, onClose, user }) => {
  const currentPage = window.location.pathname.split("/")[1];

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleNavigate = (href) => {
    onClose();
    window.location.href = href;
  };

  const handleLogout = () => {
    onClose();
    loginService.logout();
    window.location.href = "/login";
  };

  return (
    <div className="admin-mobile-menu" role="dialog" aria-modal="true" aria-label="Menu de navegação">
      <div className="admin-mobile-menu__header">
        <a className="admin-mobile-menu__brand" href="/home" onClick={(event) => {
          event.preventDefault();
          handleNavigate("/home");
        }}>
          <img src={TextLogo} alt="Lorie" />
        </a>
        <button type="button" className="admin-mobile-menu__close" onClick={onClose} aria-label="Fechar menu">
          <img src={CloseIcon} alt="" />
        </button>
      </div>

      <div className="admin-mobile-menu__body">
        <nav className="admin-mobile-menu__links">
          {ADMIN_MENU_ITEMS.map((item) => {
            const isActive = item.isActive(currentPage);

            return (
              <a
                key={item.title}
                href={item.href}
                className={`admin-mobile-menu__link ${isActive ? "admin-mobile-menu__link--active" : ""}`}
                onClick={(event) => {
                  event.preventDefault();
                  handleNavigate(item.href);
                }}
              >
                <span className="admin-mobile-menu__link__icon">
                  {item.useUserIcon ? (
                    <UserNetworkMenuIcon />
                  ) : (
                    <img src={isActive ? item.selectedIcon : item.icon} alt="" />
                  )}
                </span>
                <span className="admin-mobile-menu__link__label">{item.title}</span>
              </a>
            );
          })}
        </nav>
      </div>

      <div className="admin-mobile-menu__footer">
        <div className="admin-mobile-menu__user">
          <div className="admin-mobile-menu__user__avatar">
            {user?.photo_url ? (
              <img src={user.photo_url} alt="" />
            ) : (
              getUserInitials(user?.name)
            )}
          </div>
          <div className="admin-mobile-menu__user__info">
            <p className="admin-mobile-menu__user__name">{user?.name}</p>
            <p className="admin-mobile-menu__user__email">{user?.email}</p>
          </div>
        </div>
        <button type="button" className="admin-mobile-menu__logout" onClick={handleLogout}>
          Sair da conta
        </button>
      </div>
    </div>
  );
};

export default AdminMobileMenu;
